<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Report'
}
</script>

<style scoped>

</style>